var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPictoTech(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 47.6953V54.7266C0 55.6992 0.785156 56.4844 1.75781 56.4844H8.78906V45.9375H1.75781C0.785156 45.9375 0 46.7227 0 47.6953ZM58.2422 3.51562H51.2109V14.0625H58.2422C59.2148 14.0625 60 13.2773 60 12.3047V5.27344C60 4.30078 59.2148 3.51562 58.2422 3.51562ZM40.5469 0C36.3047 0 32.7539 3.02344 31.9336 7.03125L30.1172 8.78906L31.9336 10.5469C32.7539 14.5547 36.3047 17.5781 40.5469 17.5781H45.9375L46.6406 14.5312V3.75L45.9375 0H40.5469ZM19.4531 42.4219H14.0625L12.3047 45.8203V57.4219L14.0625 60H19.4531C23.6953 60 27.2461 56.9766 28.0664 52.9688L29.5312 51.2109L28.0664 49.4531C27.2461 45.4453 23.6953 42.4219 19.4531 42.4219Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.03125 44.1797V58.2422C7.03125 59.2148 7.81641 60 8.78906 60H14.0625V42.4219H8.78906C7.81641 42.4219 7.03125 43.207 7.03125 44.1797ZM51.2109 0H45.9375V17.5781H51.2109C52.1836 17.5781 52.9688 16.793 52.9688 15.8203V1.75781C52.9688 0.785156 52.1836 0 51.2109 0ZM31.7578 37.3125C33.9492 35.25 35.2734 32.2852 35.2734 29.168V24.3047C33.7734 23.7773 32.5898 22.582 32.0625 21.0938H31.7578V37.3125ZM28.2422 21.0938H27.9375C27.4102 22.5938 26.2148 23.7773 24.7266 24.3047V29.168C24.7266 32.2852 26.0508 35.2383 28.2422 37.3125V21.0938ZM40.5469 28.2422H38.7891V29.168C38.7891 30.0469 38.707 30.9141 38.5547 31.7578H40.5469C45.375 31.7578 49.4531 35.8359 49.4531 40.6641C49.4531 46.8984 43.3125 49.4531 37.0312 49.4531H28.0664C28.1836 50.0156 28.2422 50.6133 28.2422 51.2109C28.2422 51.8086 28.1836 52.4062 28.0664 52.9688H37.0312C47.8594 52.9688 52.9688 47.0508 52.9688 40.6641C52.9688 33.8672 47.3555 28.2422 40.5469 28.2422ZM21.2109 28.2422H19.4531C14.6016 28.2422 10.6641 24.2461 10.6641 19.3359C10.6641 14.4844 14.6016 10.5469 19.4531 10.5469H31.9336C31.8164 9.98438 31.7578 9.38672 31.7578 8.78906C31.7578 8.19141 31.8164 7.59375 31.9336 7.03125H19.4531C12.668 7.03125 7.14844 12.5508 7.14844 19.3359C7.14844 26.1797 12.668 31.7578 19.4531 31.7578H21.4453C21.293 30.9141 21.2109 30.0469 21.2109 29.168V28.2422Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0586 40.0547H21.2461C20.6016 40.0547 20.0742 39.5274 20.0742 38.8828V21.0703C20.0742 20.4258 20.6016 19.8984 21.2461 19.8984H39.0586C39.7031 19.8984 40.2305 20.4258 40.2305 21.0703V38.8828C40.2305 39.5274 39.7031 40.0547 39.0586 40.0547Z",
    fill: "url(#paint2_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 30,
    y1: 60,
    x2: 30,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD3A84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA68D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 30,
    y1: 60,
    x2: 30,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC2CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF2F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 30.1496,
    y1: 40.0494,
    x2: 30.1496,
    y2: 19.8931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD3A84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA68D"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoTech);
export default __webpack_public_path__ + "static/media/picto_tech.0be7fb6e217bebed8aa6db7f1fa77cba.svg";
export { ForwardRef as ReactComponent };